'use client';

import { purchaseFormCtx } from './purchaseFormCtx';

/**
 * Returns a getter function for the purchase form values.
 *
 * @returns A function that returns `getValues()` from the purchase form controller
 *
 * @example
 * const getValues = usePurchaseFormValue();
 * getValues(); // { quantity: ..., purchaseOption: ... }
 *
 * @example
 * const getValues = usePurchaseFormValue();
 * getValues('quantity'); // quantity value
 */
export function usePurchaseFormValue() {
    return purchaseFormCtx.getValues;
}
